// src/components/HeroSections.jsx
import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./HeroSections.css";
import { motion } from "framer-motion";

const HeroSections = () => {
  const VIDEO_BASE_URL = process.env.REACT_APP_Video_BASE_URL;
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };

  const handleVideoLoaded = () => {
    setIsVideoLoaded(true);
  };

  const headingRef = useRef(null);
  const paraRef = useRef(null);
  const [headingVisible, setHeadingVisible] = useState(false);
  const [paraVisible, setParaVisible] = useState(false);

  // Simple observer for fade/slide animation on scroll
  const createToggleObserver = (ref, setVisible) => {
    const el = ref.current;
    if (!el) return null;
    const observer = new IntersectionObserver(
      ([entry]) => setVisible(entry.isIntersecting),
      { threshold: 0.5 }
    );
    observer.observe(el);
    return observer;
  };

  useEffect(() => {
    const observer = createToggleObserver(headingRef, setHeadingVisible);
    return () => observer && observer.disconnect();
  }, []);

  useEffect(() => {
    const observer = createToggleObserver(paraRef, setParaVisible);
    return () => observer && observer.disconnect();
  }, []);

  return (
    <section id="home-section" className="home-hero">
      <div className="hero-container text-white">
        <video
          ref={videoRef}
          className="bg-video"
          src={`${VIDEO_BASE_URL}/popup-video.mp4`}
          type="video/mp4"
          preload="auto"
          muted
          loop
          playsInline
          autoPlay
          webkit-playsinline="true"
          onLoadedData={handleVideoLoaded}
          style={{
            opacity: isVideoLoaded ? 1 : 0,
            transition: "opacity 0.3s ease",
          }}
        ></video>

        <div
          id="overlay-left"
          className="overlay-left d-flex align-items-center"
        >
          <div className="container">
            <motion.div
              className="col-md-7"
              initial={{ x: -100, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            >
              {/* Static heading */}
              <h1
                ref={headingRef}
                className={`animated-heading ${headingVisible ? "animate" : ""}`}
                id="heading"
              >
                Welcome to Aanandam Valleey – Barsana
              </h1>

              {/* Static subheading */}
              <p
                ref={paraRef}
                className={`animated-subheading lead mt-3 ${
                  paraVisible ? "animate" : ""
                }`}
                id="subheading"
              >
                The Spiritual Soul Of India
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSections;
